"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventStatusMessageProperty = exports.eventStatusMessagePropertyDefinition = void 0;
exports.eventStatusMessagePropertyDefinition = {
    name: 'event-status-message',
    type: 'text',
    constraints: [
        {
            name: 'maxLength',
            argument: 200,
        },
    ],
    multiple: false,
    view: {
        label: 'Status Message',
        hint: 'Provide additional information for the status',
    },
};
const isEventStatusMessageProperty = (prop) => {
    return prop.name === exports.eventStatusMessagePropertyDefinition.name;
};
exports.isEventStatusMessageProperty = isEventStatusMessageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtc3RhdHVzLW1lc3NhZ2UucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9ldmVudC1zdGF0dXMtbWVzc2FnZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLG9DQUFvQyxHQUFHO0lBQ2xELElBQUksRUFBRSxzQkFBc0I7SUFDNUIsSUFBSSxFQUFFLE1BQU07SUFDWixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxHQUFHO1NBQ2Q7S0FDRjtJQUNELFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGdCQUFnQjtRQUN2QixJQUFJLEVBQUUsK0NBQStDO0tBQ3REO0NBQzhCLENBQUE7QUFJMUIsTUFBTSw0QkFBNEIsR0FBRyxDQUFDLElBQWtCLEVBQXNDLEVBQUU7SUFDckcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDRDQUFvQyxDQUFDLElBQUksQ0FBQTtBQUNoRSxDQUFDLENBQUE7QUFGWSxRQUFBLDRCQUE0QixnQ0FFeEMifQ==